import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#DB2F91" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              The ButtonSmasher application adopted a very interactive UI, with
              a tinder-like swipe functionality to make the app fun to use. The
              implementation of the Swipe function allows users to swipe in four
              different directions, each one preset to a specific task such as,
              rating and reviews, game information, gameplay video and so on.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center mt-3"
          >
            <StaticImage
              src="../../../images/case-studies/button-smasher/highlights_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2195}
              height={921}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
